import { bool } from 'prop-types'
import Collapse from 'gatsby-theme-marketplace-base/src/components/Collapse'

const CollapseWrapper = ({ isOpenOnInit, ...rest }) => {
  return <Collapse {...rest} isOpenOnInit={isOpenOnInit ?? true} />
}

CollapseWrapper.propTypes = {
  isOpenOnInit: bool,
}

export default (props) => <CollapseWrapper {...props} />
